const OPEN_MOBILE_SPECIFICATION = "OPEN_MOBILE_SPECIFICATION";

export const returnComponent = (choice) => { return { type: OPEN_MOBILE_SPECIFICATION, choice: choice } }

// open and close component
export const renderComponent = (choice) => (dispatch) => {
    dispatch(returnComponent(choice));
}

export const initialState = {
    choice: 'table',
}

export default (state = initialState, action) => {
    switch (action.type) {
        case OPEN_MOBILE_SPECIFICATION:
            return { ...state, choice: action.choice };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/society/mob-specification-reducer.js